
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30176',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30176",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54378",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7962",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11406",
  "I18n": "static-7.1610",
  "quartz": "static-1.6947",
  "quartz-config": "static-1.725",
  "quartz-core": "static-1.6166",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.778",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54365",
  "feedback-utils": "static-1.54369",
  "forms-embed-utils-lib": "static-1.4407",
  "forms-utils-lib": "static-1.12468",
  "foundations-assets": "static-1.4799",
  "foundations-components": "static-1.7817",
  "foundations-theming": "static-1.4361",
  "hub-http": "static-1.6167",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11714",
  "icons": "static-2.643",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3871",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16609",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5298",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57316",
  "transmute": "static-2.85",
  "ui-images": "static-2.1138",
  "UIComponents": "static-3.8353",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3358",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3224",
  "quartz-webpack": "static-1.3171",
  "foundations-theming-specialty": "static-1.2077",
  "property-description-translator": "static-1.3794",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3073",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4271",
  "jasmine-runner": "static-1.6416",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4606",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.622",
  "quartz-head": "static-1.612",
  "quartz-i18n": "static-1.622",
  "quartz-routing": "static-1.377",
  "quartz-test": "static-1.622",
  "quartz-tracking": "static-1.326",
  "ui-fonts": "static-1.668",
  "usage-tracker-container": "static-1.7273",
  "usage-tracker-core": "static-1.7133",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7195",
  "reference-resolvers": "static-1.8116",
  "sanitize-text": "static-1.8089",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10318",
  "sanitize": "static-1.4419",
  "outpost": "static-1.4135",
  "rpc-client-utils": "static-1.4593",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4086",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9375",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1642",
  "bend-plugin-foundations-theming": "static-1.2844",
  "foundations-theming-base": "static-1.3346",
  "stylex": "static-1.31",
  "hs-locale-management": "static-1.38",
  "csstype": "static-1.50",
  "web-vitals": "static-1.3",
  "ai-components-ui-library": "static-1.8788",
  "atom": "static-1.5018",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7662",
  "ContentUtils": "static-1.68189",
  "data-token-picker": "static-1.16300",
  "file-manager-components": "static-1.23452",
  "FileManagerCore": "static-1.38951",
  "FileManagerLib": "static-1.39092",
  "frontend-preferences-client": "static-1.7873",
  "hub-http-contrib": "static-1.2986",
  "interframe": "static-3.4707",
  "layout-dnd-components": "static-1.12330",
  "layout-dnd-utils": "static-1.11305",
  "property-translator": "static-1.5349",
  "react-codemirror": "static-1.10570",
  "react-colorpicker": "static-2.10157",
  "reference-resolvers-lite": "static-1.8039",
  "rich-text-lib": "static-1.19728",
  "tinymce-data": "static-1.40287",
  "tinymce-themes": "static-1.56172",
  "ui-addon-emoji-picker": "static-1.9834",
  "ui-addon-sales-email": "static-1.5156",
  "ui-brand-identity-lib": "static-1.14978",
  "bender-build-tools": "static-1.3123",
  "hub-http-shared-msw-handlers": "static-1.9829",
  "hubspotter-http-shared-msw-handlers": "static-1.9827",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4969",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1832",
  "chatspot-core": "static-1.21010",
  "copilot-toolkit": "static-1.10963",
  "customer-data-objects-ui-components": "static-1.12968",
  "data-fetching-client": "static-1.9619",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4713",
  "ui-addon-video-player": "static-1.8644",
  "ui-coaching-tips": "static-1.28382",
  "usage-tracker": "static-1.7283",
  "cms-field-types": "static-1.4757",
  "content-icons-ui": "static-1.2211",
  "integrations-lib": "static-1.15931",
  "customer-data-objects": "static-1.7606",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4595",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4100",
  "ui-addon-iframeable": "static-1.8999",
  "video-components-external": "static-1.11083",
  "video-data-lib": "static-1.34741",
  "audio-components": "static-1.5827",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29192",
  "FileManagerImages": "static-1.36603",
  "foundations-components-legacy": "static-1.842",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8904",
  "urlinator": "static-1.4478",
  "video-components": "static-1.13086",
  "video-embed": "static-1.35575",
  "ts-schema": "static-1.4032",
  "ContentData": "static-1.68264",
  "layout-data-lib": "static-1.9630",
  "react-dnd-compat": "static-1.4566",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1497",
  "external-options-client-types": "static-1.4113",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6823",
  "hs-promise-utils": "static-1.5539",
  "inbound-db-properties-service-client": "static-1.3795",
  "NamespacedHubStyle": "static-2.9017",
  "growth-onboarding-confetti": "static-1.3014",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11097",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5523",
  "magpie-types": "static-1.4983",
  "simple-logging-lib": "static-1.2995",
  "avatar-components": "static-1.2442",
  "customer-data-ui-utilities": "static-1.9772",
  "growth-onboarding-feedback-components": "static-1.6530",
  "flux-actions": "static-1.330",
  "hubspot-apollo-client": "static-1.4823",
  "integrations-error-boundary-lib": "static-1.13346",
  "integrations-tracking-lib": "static-1.5542",
  "laboratory-lib": "static-3.7105",
  "native-integrations-shared-strings": "static-1.7730",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10095",
  "unified-auth": "static-1.418",
  "navigation-messaging": "static-1.7150",
  "content-media-composition-data-lib": "static-1.12058",
  "content-media-compositions": "static-2.16065",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18824",
  "unified-auth-core-lib": "static-1.699",
  "social-insights-client-types": "static-1.21922",
  "advanced-menus-core": "static-1.15036",
  "advanced-menus-lib": "static-1.11990",
  "ExportDialog": "static-6.10339",
  "ui-memberships-settings-lib": "static-1.33887",
  "conditional-properties-service-client": "static-1.3751",
  "crm-pipelines-api-client-types": "static-1.4097",
  "framework-builder-read-service-client": "static-1.3964",
  "framework-data-schema-quick-fetch": "static-1.6728",
  "inbound-db-meta-service-client": "static-1.3545",
  "multi-currency-client-types": "static-1.3646",
  "persist-promise": "static-1.3654",
  "foundations-components-test-utils": "static-1.5300",
  "reactive-lib": "static-1.667",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.282",
  "universal-page-editor-lib": "static-1.2957",
  "google-sheets-integration-lib": "static-1.66",
  "microsoft-drive-integration-lib": "static-1.173",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3679",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15035",
  "simple-menus-lib": "static-1.16552",
  "crm-record-cards-service-types": "static-1.3565",
  "location-customization-utils-lib": "static-1.9072",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30176",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54378",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7962",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11406",
  "I18n": "/I18n/static-7.1610",
  "quartz": "/quartz/static-1.6947",
  "quartz-config": "/quartz-config/static-1.725",
  "quartz-core": "/quartz-core/static-1.6166",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.778",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54365",
  "feedback-utils": "/feedback-utils/static-1.54369",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4407",
  "forms-utils-lib": "/forms-utils-lib/static-1.12468",
  "foundations-assets": "/foundations-assets/static-1.4799",
  "foundations-components": "/foundations-components/static-1.7817",
  "foundations-theming": "/foundations-theming/static-1.4361",
  "hub-http": "/hub-http/static-1.6167",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11714",
  "icons": "/icons/static-2.643",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3871",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16609",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5298",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57316",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1138",
  "UIComponents": "/UIComponents/static-3.8353",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3358",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3224",
  "quartz-webpack": "/quartz-webpack/static-1.3171",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2077",
  "property-description-translator": "/property-description-translator/static-1.3794",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3073",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4271",
  "jasmine-runner": "/jasmine-runner/static-1.6416",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4606",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.622",
  "quartz-head": "/quartz-head/static-1.612",
  "quartz-i18n": "/quartz-i18n/static-1.622",
  "quartz-routing": "/quartz-routing/static-1.377",
  "quartz-test": "/quartz-test/static-1.622",
  "quartz-tracking": "/quartz-tracking/static-1.326",
  "ui-fonts": "/ui-fonts/static-1.668",
  "usage-tracker-container": "/usage-tracker-container/static-1.7273",
  "usage-tracker-core": "/usage-tracker-core/static-1.7133",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7195",
  "reference-resolvers": "/reference-resolvers/static-1.8116",
  "sanitize-text": "/sanitize-text/static-1.8089",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10318",
  "sanitize": "/sanitize/static-1.4419",
  "outpost": "/outpost/static-1.4135",
  "rpc-client-utils": "/rpc-client-utils/static-1.4593",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4086",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9375",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1642",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2844",
  "foundations-theming-base": "/foundations-theming-base/static-1.3346",
  "stylex": "/stylex/static-1.31",
  "hs-locale-management": "/hs-locale-management/static-1.38",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.3",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8788",
  "atom": "/atom/static-1.5018",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7662",
  "ContentUtils": "/ContentUtils/static-1.68189",
  "data-token-picker": "/data-token-picker/static-1.16300",
  "file-manager-components": "/file-manager-components/static-1.23452",
  "FileManagerCore": "/FileManagerCore/static-1.38951",
  "FileManagerLib": "/FileManagerLib/static-1.39092",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7873",
  "hub-http-contrib": "/hub-http-contrib/static-1.2986",
  "interframe": "/interframe/static-3.4707",
  "layout-dnd-components": "/layout-dnd-components/static-1.12330",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11305",
  "property-translator": "/property-translator/static-1.5349",
  "react-codemirror": "/react-codemirror/static-1.10570",
  "react-colorpicker": "/react-colorpicker/static-2.10157",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8039",
  "rich-text-lib": "/rich-text-lib/static-1.19728",
  "tinymce-data": "/tinymce-data/static-1.40287",
  "tinymce-themes": "/tinymce-themes/static-1.56172",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9834",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5156",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14978",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9829",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9827",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4969",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1832",
  "chatspot-core": "/chatspot-core/static-1.21010",
  "copilot-toolkit": "/copilot-toolkit/static-1.10963",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12968",
  "data-fetching-client": "/data-fetching-client/static-1.9619",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4713",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8644",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28382",
  "usage-tracker": "/usage-tracker/static-1.7283",
  "cms-field-types": "/cms-field-types/static-1.4757",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "integrations-lib": "/integrations-lib/static-1.15931",
  "customer-data-objects": "/customer-data-objects/static-1.7606",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4595",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4100",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8999",
  "video-components-external": "/video-components-external/static-1.11083",
  "video-data-lib": "/video-data-lib/static-1.34741",
  "audio-components": "/audio-components/static-1.5827",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29192",
  "FileManagerImages": "/FileManagerImages/static-1.36603",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.842",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8904",
  "urlinator": "/urlinator/static-1.4478",
  "video-components": "/video-components/static-1.13086",
  "video-embed": "/video-embed/static-1.35575",
  "ts-schema": "/ts-schema/static-1.4032",
  "ContentData": "/ContentData/static-1.68264",
  "layout-data-lib": "/layout-data-lib/static-1.9630",
  "react-dnd-compat": "/react-dnd-compat/static-1.4566",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1497",
  "external-options-client-types": "/external-options-client-types/static-1.4113",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6823",
  "hs-promise-utils": "/hs-promise-utils/static-1.5539",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3795",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9017",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3014",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11097",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5523",
  "magpie-types": "/magpie-types/static-1.4983",
  "simple-logging-lib": "/simple-logging-lib/static-1.2995",
  "avatar-components": "/avatar-components/static-1.2442",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9772",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6530",
  "flux-actions": "/flux-actions/static-1.330",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4823",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13346",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5542",
  "laboratory-lib": "/laboratory-lib/static-3.7105",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7730",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10095",
  "unified-auth": "/unified-auth/static-1.418",
  "navigation-messaging": "/navigation-messaging/static-1.7150",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12058",
  "content-media-compositions": "/content-media-compositions/static-2.16065",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18824",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.699",
  "social-insights-client-types": "/social-insights-client-types/static-1.21922",
  "advanced-menus-core": "/advanced-menus-core/static-1.15036",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11990",
  "ExportDialog": "/ExportDialog/static-6.10339",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33887",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3751",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4097",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3964",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6728",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3545",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3646",
  "persist-promise": "/persist-promise/static-1.3654",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5300",
  "reactive-lib": "/reactive-lib/static-1.667",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.282",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2957",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.66",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.173",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3679",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15035",
  "simple-menus-lib": "/simple-menus-lib/static-1.16552",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3565",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9072",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
